import { render, staticRenderFns } from "./center-map.vue?vue&type=template&id=387434d8&scoped=true&"
import script from "./center-map.vue?vue&type=script&lang=js&"
export * from "./center-map.vue?vue&type=script&lang=js&"
import style0 from "./center-map.vue?vue&type=style&index=0&id=387434d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387434d8",
  null
  
)

export default component.exports